<template>
  <div class="wrapper">
    <finding-hint-popup
      :isShownFindingHint="isShownFindingHint"
      :examinationType="examinationType"
    ></finding-hint-popup>
        <v-tabs
      :key="filteredFindingsKey"
      height:80px
      v-model="activeFilteredIndex"
      class="mt-2"
      :class="[examinationType == 1 ? 'elevation-1' : 'elevation-2', {'no-image-list': closeImageList}]"
    >
      <v-tab
        class="findingTab"
        v-for="(item, filteredIndex) in filteredFindings"
        :key="item.originalIndex"
        ripple
      >
        <div class="d-flex d-md-block align-center">
          <h1 class="fsz-10 fsz-md-12">{{ filteredIndex + 1 }}</h1>
          <h2 class="fsz-14 fsz-md-18">{{ transI18n(getFindingName( item.originalIndex + 1 )) }}</h2>
        </div>
      </v-tab>
      <v-spacer></v-spacer>
      <div class="v-tabs__div">
        <icon-button-with-tooltip
          className="add-finding-btn"
          color="grey darken-1"
          flat
          small
          iconName="add"
          tooltipText="Add new finding"
          @click="addFinding()"
        ></icon-button-with-tooltip>
        <icon-button-with-tooltip
          v-if="getFindings && getFindings.length <= 0"
          color="grey darken-1"
          flat
          small
          iconName="keyboard_voice"
          tooltipText="show hint"
          @click="showHint()"
        ></icon-button-with-tooltip>
      </div>
      <v-tab-item
        v-for="item in filteredFindings"
        :key="item.originalIndex"
        :class="[getStoreHiddenParameter.over ? 'disabled' : '']"
      >
        <ConfirmDialogSmall
          :showDialog="deleteDialog"
          :title="$t('examination_detail.delete_finding')"
          :message="deleteMessage"
          :onConfirm="onDeleteConfirm.bind(this)"
          :onCancel="onDeleteCancel.bind(this)"
        ></ConfirmDialogSmall>
        <PreviewFindingsFormLevelOne
          :finding="item.finding"
          :findingIndex="item.originalIndex"
          :questions="getQuestionsList"
          :hiddenParams="getStoreHiddenParameter"
          :transI18n="transI18n"
          isExamination
          fieldIsRequired
          @change="
            saveQuestionInput({ findingIndex: item.originalIndex, event: $event })
          "
          class="pa-3"
        >
        </PreviewFindingsFormLevelOne>
        <v-tabs :value="getNowRecordIndex">
          <v-tab
            v-for="(record, recordIndex) in item.finding.records"
            :key="recordIndex"
            @click="openRecordIndex(recordIndex)"
          >
            <div v-if="isMostSignificant(item.finding)" class="fsz-20">The most significant</div>
            <div v-else-if="isOverall(item.finding)" class="fsz-20">Overall</div>
            <div v-else class="fsz-20">
              Lesion
              <span v-if="item.finding.records.length > 1">{{
                recordIndex + 1
              }}</span>
            </div>
          </v-tab>
          <v-tab-item
            class="wavemed-horizontal-stepper-container px-2"
            v-for="(record, recordIndex) in item.finding.records"
            :key="recordIndex"
          >
            <PreviewFindingsFormLevelTwo
              :findingIndex="item.originalIndex"
              :recordIndex="recordIndex"
              :record="record"
              :examination_typeID="
                getExaminationData.examination.examination_typeID
              "
              :questions="getQuestionsList"
              :hiddenParams="getStoreHiddenParameter"
              hideLocationImage
              isExamination
              :transI18n="transI18n"
              @change="
                saveQuestionInput({
                  findingIndex: item.originalIndex,
                  recordIndex: recordIndex,
                  event: $event,
                })
              "
              @addLocation="
                addExaminationLocation({ recordID: record.id, findingIndex: item.originalIndex })
              "
              @deleteLocation="
                deleteExaminationLocation({
                  locationID: $event,
                  recordIndex,
                  findingIndex: item.originalIndex,
                })
              "
              @locationChange="
                updateExaminationLocationColumn({
                  findingIndex: item.originalIndex,
                  recordIndex,
                  $event,
                })
              "
            >
            </PreviewFindingsFormLevelTwo>
          </v-tab-item>
        </v-tabs>

        <v-layout align-center justify-center class="pb-2">
          <v-btn flat outline color="red" @click.stop="onOpenDeleteDialog()">
            <v-icon>delete</v-icon>
            {{ $t('examination_detail.delete_finding') }}
          </v-btn>
        </v-layout>
      </v-tab-item>
    </v-tabs>
    <div v-if="getFindings && getFindings.length <= 0" class="no-data">
      <p>No Finding</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import IconButtonWithTooltip from "@/components/IconButtonWithTooltip.vue";
import PreviewFindingsFormLevelOne from "@/views/admin/components/gastro-article/PreviewFindingsFormLevelOne.vue";
import PreviewFindingsFormLevelTwo from "@/views/admin/components/gastro-article/PreviewFindingsFormLevelTwo.vue";
import ConfirmDialogSmall from "@/components/ConfirmDialogSmall.vue";
import FindingHintPopup from "@/components/examinations/FindingHintPopup.vue";
import { questionUpdateMixin } from '@/mixins/questionUpdateMixin';

export default {
  name: "PreviewFinding",
  mixins: [questionUpdateMixin],
  props: {
    transI18n: {
      type: Function,
      required: true,
    },
    findingIdFilter: {
      type: [Number, String],
      default: null,
    },
  },
  components: {
    IconButtonWithTooltip,
    PreviewFindingsFormLevelTwo,
    PreviewFindingsFormLevelOne,
    ConfirmDialogSmall,
    FindingHintPopup,
  },

  prop() {}
,
  data() {
    return {
      deleteDialog: false,
      deleteMessage: "",
      isShownFindingHint: false,
    };
  },

  computed: {
    ...mapGetters(['getSetting']),
    ...mapGetters("examinations", [
      "getDoctorList",
      "getTechnicalStaffList",
      "getExaminationData",
      "getLandmarkList",
      "getExaminationTypeList",
      "getPatient",
      "getQuestionsList",
      "getExaminationFinishDialog",
      "getStoreHiddenParameter",
    ]),

    ...mapGetters(["getLoading"]),

    getExaminationInfo() {
      return this.getExaminationData.examination;
    },

    getFindings() {
      return this.getExaminationData ? this.getExaminationData.findings : null;
    },

    getFindingsLength() {
      return this.getFindings ? this.getFindings.length : 0;
    },

    getNowRecordIndex() {
      return this.getStoreHiddenParameter.nowRecordIndex;
    },

    examinationID() {
      if (Number(this.$route.params.examinationID) != 0) {
        return this.$route.params.examinationID;
      } else {
        if (this.getExaminationData != null) {
          return this.getExaminationData.examination.id;
        }
      }
    },
    accNo() {
      return Number(this.$route.params.accNo) != 0
        ? this.$route.params.accNo
        : 0;
    },

    examinationFinishDialog() {
      return this.getExaminationFinishDialog;
    },
    isRecording() {
      return this.getStoreHiddenParameter.isRecording;
    },
    isTimeCounting() {
      return this.getStoreHiddenParameter.isTimeCounting;
    },
    isTimeFinish() {
      return this.getStoreHiddenParameter.isTimeFinish;
    },
    examinationType() {
      // 1 => Gastroscopy, 2=> Colonoscopy, 3 => Sigmoidoscopy
      return this.getExaminationData.examination.examination_typeID;
    },
    closeImageList() {
      return !this.getSetting.screenshot
    },

    filteredFindings() {
      if (!this.getFindings) {
        return [];
      }
      // 不再使用名稱過濾；直接顯示所有 findings。
      return this.getFindings.map((finding, index) => ({ finding, originalIndex: index }));
    },

    // 用於在切換模版/過濾條件時強制重建 v-tabs，避免內部狀態殘留
    filteredFindingsKey() {
      return this.filteredFindings.map(i => i.originalIndex).join(',');
    },

    activeFilteredIndex: {
      get() {
        const originalIndex = this.getStoreHiddenParameter.nowFindingIndex;
        const filteredIndex = this.filteredFindings.findIndex(item => item.originalIndex === originalIndex);
        return filteredIndex > -1 ? filteredIndex : null;
      },
      set(newFilteredIndex) {
        if (typeof newFilteredIndex === 'number' && this.filteredFindings[newFilteredIndex]) {
          const originalIndex = this.filteredFindings[newFilteredIndex].originalIndex;
          if (this.getStoreHiddenParameter.nowFindingIndex !== originalIndex) {
            this.setStoreHiddenParameter({
              target: "nowFindingIndex",
              value: originalIndex,
            });
            this.openRecordIndex(0);
          }
        }
      }
    },
  },

  watch: {
    filteredFindings(newFindings) {
      const currentOriginalIndex = this.getStoreHiddenParameter.nowFindingIndex;
      const indexInNewList = newFindings.findIndex(item => item.originalIndex === currentOriginalIndex);

      if (indexInNewList === -1) {
        if (newFindings.length > 0) {
          this.setStoreHiddenParameter({
            target: "nowFindingIndex",
            value: newFindings[0].originalIndex,
          });
        } else {
          this.setStoreHiddenParameter({
            target: "nowFindingIndex",
            value: 0,
          });
        }
      }
    }
  },

  methods: {
      ...mapActions('examinations', [
        'updateExaminationColumn',
        'addExaminationSedative',
        'deleteExaminationSedative',
        'addExaminationLocation',
        'deleteExaminationLocation',
        'updateExaminationLocationColumn',
        'setExaminationFinishDialog',
        'setStoreHiddenParameter',
        'setRecording',
        'setTimeCounting',
        'setTimeFinish'
    ]),

    ...mapActions('screenshots', [
        'setScreenshotGroup',
        'setScreenshotStatus',
        'deleteScreenshot'
    ]),

    getFindingName(n) {
        const user = sessionStorage.getItem("user")
        const userObject = JSON.parse(user);
        const username = userObject.username;
        let arr = []
        let findingName = []
        if (username === "demo") {
          if (this.getQuestionsList == null) {
          return
        } else if (this.getQuestionsList[215]) {
          for (let i in this.getFindings) {
            if(this.getFindings[i] && this.getFindings[i].questions && this.getFindings[i].questions.finding && this.getFindings[i].questions.finding.value){
              arr.push(this.getFindings[i].questions.finding.value)
            }
          }
          // find the gastro
          findingName = this.getQuestionsList[215].options[arr[n-1]]
        } else if (this.getQuestionsList[216]) {
          for (let i in this.getFindings) {
            if(this.getFindings[i] && this.getFindings[i].questions && this.getFindings[i].questions.finding && this.getFindings[i].questions.finding.value){
              arr.push(this.getFindings[i].questions.finding.value)
            }
          }
          findingName = this.getQuestionsList[216].options[arr[n - 1]];
        }
        }

        if (this.getQuestionsList == null) {
          return
        } else if (this.getQuestionsList[19]) {
          for (let i in this.getFindings) {
            if(this.getFindings[i] && this.getFindings[i].questions && this.getFindings[i].questions.finding && this.getFindings[i].questions.finding.value){
              arr.push(this.getFindings[i].questions.finding.value)
            }
          }
          // find the gastro
          findingName = this.getQuestionsList[19].options[arr[n-1]]
        } else if (this.getQuestionsList[20]) {
          for (let i in this.getFindings) {
            if(this.getFindings[i] && this.getFindings[i].questions && this.getFindings[i].questions.finding && this.getFindings[i].questions.finding.value){
              arr.push(this.getFindings[i].questions.finding.value)
            }
          }
          findingName = this.getQuestionsList[20].options[arr[n - 1]];
        }
        // find the gastro
      return findingName;
    },

    isMostSignificant(finding) {
      return (
        finding.records.length > 0 &&
        finding.questions.takeNote &&
        Number(finding.questions.takeNote.value) == 499
      );
    },

    isOverall(finding) {
      return (
        finding.records.length > 0 &&
        finding.questions.takeNote &&
        Number(finding.questions.takeNote.value) == 501
      );
    },

    isEmptyStr(str) {
      return str && str.trim().replace(" ", "") === "" ? true : false;
    },

    setExaminationColumn(column, value) {
      let d = {
        id: this.examinationID,
        column: column,
        value: value,
      };
      this.updateExaminationColumn(d);
    },

    setExaminationStatus() {
      this.setExaminationColumn("status", 2);
      this.$router.push({
        path: `/home`,
      });
    },

    addFinding() {
      const examinationID = this.getExaminationData.examination.id;
      let findingId = this.findingIdFilter || null;

      this.$store
        .dispatch("examinations/addFinding", examinationID)
        .then(() => {
          this.setStoreHiddenParameter({
            target: "nowFindingIndex",
            value: this.getExaminationData.findings.length - 1,
          });
          this.setStoreHiddenParameter({
            target: "nowQuestionPart",
            value: "d",
          });
          this.setStoreHiddenParameter({
            target: "focus",
            value: "finding",
          });
          this.setStoreHiddenParameter({
            target: "over",
            value: false,
          });
          // 若外層提供了 findingIdFilter，預設選單值為該 id
          if (findingId) {
            const lastIndex = this.getExaminationData.findings.length - 1;
            const newFindingEntityId = this.getExaminationData.findings[lastIndex] && this.getExaminationData.findings[lastIndex].id;
            if (newFindingEntityId) {
              const payload = {
                examination_typeID: this.getExaminationInfo.examination_typeID,
                findingIndex: lastIndex,
                findingID: newFindingEntityId,
                field: 'finding',
                value: String(findingId),
              };
              this.$store.dispatch("examinations/updateFindingQuestions", payload);
            }
          }
        });
    },

    deleteFinding(n) {
      const findingID = this.getFindings[n].id;

      this.$store.dispatch("examinations/deleteFinding", {
        findingID,
        findingIndex: n,
      });
    },

    async saveQuestionInput(obj) {
      const findingIndex = obj.findingIndex;
      const recordIndex = obj.recordIndex;
      const field = obj.event.field;
      const value = obj.event.newValue;
      const item = obj.event.item;

      let d = {
        examination_typeID: this.getExaminationInfo.examination_typeID,
        findingIndex,
        recordIndex,
        findingID: this.getFindings[findingIndex].id,
        field,
        value,
        item,
      };

      if (typeof d.value == "string") {
        d.value = d.value.replace(/\'/gi, "\\'");
      }

      if (recordIndex !== undefined) {
        d.recordID = this.getFindings[findingIndex].records[recordIndex].id;
      }

      if (field == "takeNote") {
        if (value == "499" || value == "501") {
          this.setStoreHiddenParameter({
            target: "nowRecordIndex",
            value: 0,
          });
        }
      }
      if (field == "number") {
        if (!isNaN(value) || value == "several" || value == "multiple") {
          this.setStoreHiddenParameter({
            target: "nowRecordIndex",
            value: 0,
          });
          await this.updateQuestionAndRefresh(d);
        } else {
          d.value = 1;
          await this.updateQuestionAndRefresh(d);
        }
      } else {
        let maneuver = ["coldSnare", "hotSnare", "snare"];
        if (
          d.field &&
          maneuver.indexOf(d.field) > -1 &&
          this.getFindings[findingIndex] &&
          this.getFindings[findingIndex].records &&
          this.getFindings[findingIndex].records[recordIndex]
        ) {
          let record = this.getFindings[findingIndex].records[recordIndex];
          for (let i = 0; i < maneuver.length; i++) {
            if (
              record.questions[maneuver[i]] &&
              record.questions[maneuver[i]].value &&
              record.questions[maneuver[i]].value[0]
            ) {
              console.log("which one not null? ", maneuver[i]);
              console.log(
                "value is ? ",
                record.questions[maneuver[i]].value[0]
              );
              let o = {
                examination_typeID: this.getExaminationInfo.examination_typeID,
                findingIndex,
                recordIndex,
                findingID: this.getFindings[findingIndex].id,
                field: record.questions[maneuver[i]].config.field,
                recordID:
                  this.getFindings[findingIndex].records[recordIndex].id,
                value: [null],
                item,
              };
              await this.updateQuestionAndRefresh(o);
            }
          }
        }
        await this.updateQuestionAndRefresh(d);
      }
    },

    handleExaminationChange({ column, field, event }) {
      if (typeof field != "undefined") {
        this.setExaminationColumn(field, event);
      } else {
        this.setExaminationColumn(column, event);
      }
    },

    openRecordIndex(recordIndex) {
      if (recordIndex !== undefined) {
        this.setStoreHiddenParameter({
          target: "nowRecordIndex",
          value: recordIndex,
        });
      }
      this.setStoreHiddenParameter({
        target: "nowQuestionPart",
        value: "d",
      });

      this.removeDisable();
    },

    onOpenDeleteDialog() {
      this.deleteMessage = `${this.$t('examination_detail.delete_finding_start')} ${
        this.getStoreHiddenParameter.nowFindingIndex + 1
      } ${this.$t('examination_detail.delete_finding_end')}`;
      this.deleteDialog = true;
    },

    onDeleteCancel() {
      this.deleteDialog = false;
    },

    onDeleteConfirm() {
      this.deleteDialog = false;
      this.deleteFinding(this.getStoreHiddenParameter.nowFindingIndex);
    },

    removeDisable() {
      const isDisable = this.getStoreHiddenParameter.over;
      if (isDisable) {
        this.setStoreHiddenParameter({
          target: "over",
          value: false,
        });
      }
    },

    showHint() {
      this.isShownFindingHint = true;

      setTimeout(() => {
        this.isShownFindingHint = false;
      }, 5000);
    },

  },
  // End of method
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* Make tabs consume available height within the card */
.wrapper > .v-tabs {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* Tabs header area should not grow */
.wrapper >>> .v-tabs__wrapper,
.wrapper >>> .v-slide-group__wrapper { /* Vuetify may use slide-group for tabs */
  flex: 0 0 auto;
}

/* Tab items container should fill and not overflow beyond the card */
.wrapper >>> .v-window {
  flex: 1 1 auto;
  display: flex;
  min-height: 0;
}

.wrapper >>> .v-window__container {
  flex: 1 1 auto;
  min-height: 0;
}

.wrapper >>> .v-window-item {
  height: 100%;
  overflow: visible; /* let outer preview-content handle scrolling */
}

/* Ensure our tab-item content area (class set on v-tab-item) fills height */
.wavemed-horizontal-stepper-container {
  height: 100%;
}

/* When there is no finding, keep the placeholder below the 80px tabs header */
.no-data {
  top: 80px;
}
</style>

<style lang="scss" scoped>
@import "@/styles/pages/page_examinationDetail.scss";

.wrapper {
  position: relative;
}
.disabled {
  filter: grayscale(1);
  pointer-events: none;
  opacity: 0.3;
}

.findingTab {
  display: inline-table;
  justify-content: center;
  width: 100px;
  h1 {
    height: 20px;
    width: 20px;
    font-size: 12px;
    -moz-border-radius: 70px;
    -webkit-border-radius: 70px;
    border-radius: 70px;
    margin: 3px auto;
    padding: 3px;
    color: white;
    background: #787878;
  }
  h2 {
    text-overflow: ellipsis;
    display: -webkit-box;
    width: 100px;
    height: 20px;
    overflow: hidden;
    -webkit-box-orient: vertical;
    margin-bottom: 3px;
    -webkit-line-clamp: 1;
  }
}
.findingTab.v-tab--active h1 {
  background: #82b1ff;
}

@media (max-width: 1200px) {
  .findingTab h2 {
    height: auto;
    max-height: 20px;
    -webkit-line-clamp: 2;
  }
}


</style>
